import { render, staticRenderFns } from "./BaseNewsTileDouble.vue?vue&type=template&id=6bd6cc92&"
import script from "./BaseNewsTileDouble.vue?vue&type=script&lang=js&"
export * from "./BaseNewsTileDouble.vue?vue&type=script&lang=js&"
import style0 from "./BaseNewsTileDouble.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports